export enum AlertMessages {
  DeliveryUpdated = 'deliveries_page.delivery_updated_l',
}
